// avstemming-other-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avh.common.close': 'Lukk',
  'avh.common.requestDocs': 'Be klienten om dokumentasjon',
  'avh.common.countOf': '{done} av {total}',
  'avh.common.bookedBalance': 'Bokført saldo',
  'avh.common.specDiff': 'Spesifikasjonsdifferanse',
  'avh.common.docsMissing': 'Dokumentasjon mangler',
  'avh.common.assessmentRemaining': 'Vurdering gjenstår',
  'avh.common.account': 'Konto',
  'avh.common.status': 'Status',
  'avh.common.notSet': 'Ikke satt',
  'avh.common.itemsOver90': 'Poster over 90 dager',
  'avh.common.itemsOverThreshold': 'Poster over grensen',
  'avh.common.materialityThreshold': 'Vesentlighetsgrense',
  'avh.common.openAdjustments': 'Åpne avstemmingsposter',
  'avh.common.professionalConfirmation': 'Faglig bekreftelse',
  'avh.common.reconciliation': 'Avstemming',
  'avh.common.reconciliationItems': 'Avstemmingsposter',
  'avh.common.matches': 'Stemmer',
  'avh.common.confirmed': 'Bekreftet',
  'avh.common.conclusion': 'Konklusjon',
  'avh.common.overallStatus': 'Samlet status',
  'avh.common.remainingRisk': 'Gjenstående risiko',
  'avh.common.followUpNext': 'Oppfølging neste periode',
  'avh.common.action': 'Tiltak',
  'avh.common.professionalChecklist': 'Faglig sjekkliste',
  'avh.common.openItems': 'Åpne poster',
  'avh.common.accountOverview': 'Kontooversikt',
  'avh.common.checklist': 'Sjekkliste',
  'avh.common.postings.one': '{count} postering',
  'avh.common.postings.other': '{count} posteringer',
  'avh.common.items.other': '{count} poster',
  'avh.common.items.one': '{count} post',
  'avh.assess.notAssessed': 'Ikke vurdert',
  'avh.assess.okGenuine': 'OK – posten er reell og riktig ført',
  'avh.assess.unspecifiedBalance': 'Uspesifisert saldo',
  'avh.assess.counterpartyMissing': 'Motpart mangler',
  'avh.assess.wrongAccrual': 'Feil periodisering',
  'avh.assess.misclassified': 'Feilklassifisert konto',
  'avh.assess.notGenuine': 'Ikke reell post',
  'avh.assess.settledAfter': 'Gjort opp etter periodeslutt',
  'avh.assess.awaitingDocs': 'Avventer dokumentasjon',
  'avh.assess.awaitingClient': 'Avventer klienten',
  'avh.assess.writeDown': 'Nedskrivning vurderes',
  'avh.assess.writeOff': 'Tapsføres',
  'avh.assess.followUpNext': 'Følges opp neste periode',
  'avh.level.documented': 'Dokumentasjon foreligger',
  'avh.level.documentedHint': 'Finnes det en faktura, avtale, betalingsbekreftelse eller annet grunnlag som viser hva posten er?',
  'avh.level.existence': 'Eksistens bekreftet',
  'avh.level.existenceHint': 'Er kravet eller forpliktelsen fortsatt reell på avstemmingsdatoen — ikke bare bokført?',
  'avh.level.subsequent': 'Etterfølgende betaling eller oppgjør kontrollert',
  'avh.level.subsequentHint': 'Er posten gjort opp etter periodeslutt, eller er det kontrollert at den ikke er det?',
  'avh.level.recoverability': 'Gjenvinnbarhet vurdert',
  'avh.level.recoverabilityHint': 'Kommer beløpet inn, og er behovet for nedskrivning vurdert?',
  'avh.flag.over90': 'Over 90 dager',
  'avh.flag.unusualSign': 'Uvanlig fortegn',
  'avh.flag.roundAmount': 'Rundt beløp',
  'avh.flag.noMovement': 'Ingen bevegelse i perioden',
  'avh.flag.manualPeriodEnd': 'Manuell postering ved periodeslutt',
  'avh.status.reconciled': 'Avstemt',
  'avh.status.documentedPending': 'Dokumentert · vurdering gjenstår',
  'avh.status.followUp': 'Må følges opp',
  'avh.status.critical': 'Kritisk – må avklares',
  'avh.status.toAssess': 'Må vurderes',
  'avh.dr.accountLine': 'Konto {id} {name} · {postings}',
  'avh.dr.closingBalance': 'Utgående saldo',
  'avh.dr.originalDate': 'Opprinnelig dato',
  'avh.dr.lastMovement': 'Siste bevegelse',
  'avh.dr.age': 'Alder',
  'avh.dr.materiality': 'Vesentlighet',
  'avh.dr.noThreshold': 'Ingen grense satt',
  'avh.dr.overThreshold': 'Over grensen',
  'avh.dr.underThreshold': 'Under grensen',
  'avh.dr.controlLevels': 'Kontrollnivåer',
  'avh.dr.levelsNote': 'Spesifisert er posten allerede — den er lest ut av hovedboken. De fire over er noe annet, og ingen av dem erstatter de andre.',
  'avh.dr.assessment': 'Vurdering',
  'avh.dr.rationale': 'Faglig begrunnelse',
  'avh.dr.rationaleRequired': 'Faglig begrunnelse (påkrevd)',
  'avh.dr.rationalePlaceholder': 'Hva gjelder posten, hvem er motparten, og hva bygger vurderingen på?',
  'avh.dr.actionPlaceholder': 'F.eks. Innhent avtale fra klienten, omklassifiser til 1579, eller kontroller innbetaling',
  'avh.dr.followUpDeadline': 'Frist for oppfølging',
  'avh.dr.lastAssessed': 'Sist vurdert: {trail}',
  'avh.dr.needsRationale': 'Denne vurderingen krever en begrunnelse.',
  'avh.dr.saveAssessment': 'Lagre vurdering',
  'avh.cp.counterparty': 'Motpart',
  'avh.cp.basis': 'Opprinnelig grunnlag og dokumentasjon',
  'avh.cp.dueDate': 'Forfall eller forventet oppgjørstidspunkt',
  'avh.cp.subsequent': 'Etterfølgende betaling eller oppgjør',
  'avh.cp.age': 'Alder og bevegelse siden forrige periode',
  'avh.cp.recoverable': 'Om beløpet fortsatt er reelt og gjenvinnbart',
  'avh.sec.thresholdPositive': 'Skriv vesentlighetsgrensen som et positivt tall.',
  'avh.sec.thresholdBasisRequired': 'Skriv hva grensen bygger på. Uten en begrunnelse er den bare et tall.',
  'avh.sec.basis': 'Grunnlag',
  'avh.sec.setBy': 'Satt av',
  'avh.sec.setOn': 'Satt',
  'avh.sec.thresholdNote': 'Grensen sier hvilke poster som skal vurderes hver for seg. Den slår ingen kontroll av — alle åpne poster må fortsatt behandles før området kan sendes til kontroll.',
  'avh.sec.noThresholdNote': 'Ingen vesentlighetsgrense er satt for denne perioden. Alle poster behandles likt. Grensen er byråets egen faglige vurdering — appen foreslår ingen sats.',
  'avh.sec.amountInKroner': 'Beløp i kroner',
  'avh.sec.basisPlaceholder': 'Hva bygger grensen på? F.eks. 5 % av resultat før skatt',
  'avh.sec.basisAria': 'Grunnlag for vesentlighetsgrensen',
  'avh.sec.saveThreshold': 'Lagre grensen',
  'avh.sec.removeThreshold': 'Fjern grensen',
  'avh.sec.cancel': 'Avbryt',
  'avh.sec.changeThreshold': 'Endre grensen',
  'avh.sec.setThreshold': 'Sett vesentlighetsgrense',
  'avh.sec.hideRisk': 'Skjul risikoindikatorer å vurdere',
  'avh.sec.showRisk': 'Vis risikoindikatorer å vurdere',
  'avh.sec.type': 'Type',
  'avh.sec.specified': 'Spesifisert',
  'avh.sec.documented': 'Dokumentert',
  'avh.sec.unverified': 'Ikke verifisert',
  'avh.sec.oldestItem': 'Eldste post',
  'avh.sec.notSpecified': 'Ikke spesifisert',
  'avh.sec.openAccount': 'Åpne konto',
  'avh.sec.checkedAgainst': 'Kontrolleres mot',
  'avh.sec.flaggedItems': 'Poster med varsel',
  'avh.sec.openingBalance': 'Inngående saldo',
  'avh.sec.movementInPeriod': 'Bevegelse i perioden',
  'avh.sec.specDriftAlert': 'Summen av de spesifiserte postene er {specified}, mens hovedboken viser {booked}. Differansen på {diff} er saldo som ikke er spesifisert — som regel en inngående balanse som er importert uten underliggende posteringer.',
  'avh.sec.showOpenItems': 'Vis åpne poster',
  'avh.sec.openAccountWork': 'Åpne kontoarbeidet',
  'avh.sec.noAccounts': 'Ingen kontoer er lagt til øvrig balanse i denne perioden.',
  'avh.sec.itemsIntro': 'Postene er lest ut av hovedboken og gruppert på det de gjelder, fra regnskapets begynnelse til og med {date}.',
  'avh.sec.settledOne': '{count} gruppe er gjort opp og vises ikke.',
  'avh.sec.settledMany': '{count} grupper er gjort opp og vises ikke.',
  'avh.sec.allAccountsInArea': 'Alle kontoer i området',
  'avh.sec.resetFilters': 'Nullstill filtre',
  'avh.sec.counterpartyDescription': 'Motpart / beskrivelse',
  'avh.sec.lastMovementLine': ' · siste bevegelse {date}',
  'avh.sec.actionLine': 'Tiltak: {action}',
  'avh.sec.viewAssessment': 'Se vurdering',
  'avh.sec.assess': 'Vurder',
  'avh.sec.requestDocsShort': 'Be om dokumentasjon',
  'avh.sec.noMatchingItems': 'Ingen poster passer med filtrene.',
  'avh.sec.noOpenItems': 'Ingen åpne poster på kontoene i dette området.',
  'avh.sec.sumSpecified': 'Sum spesifiserte poster',
  'avh.sec.ageDistribution': 'Aldersfordeling',
  'avh.sec.withoutDocs': 'Uten dokumentasjon',
  'avh.doc.notRecorded': 'Ikke registrert',
  'avh.doc.unknown': 'Ukjent',
  'avh.doc.title': 'Dokumentasjon og kontrollspor',
  'avh.doc.existing': 'Eksisterende dokumenter',
  'avh.doc.checked': 'Kontrollerte dokumenter',
  'avh.doc.unchecked': 'Ikke kontrollerte dokumenter',
  'avh.doc.itemsWithoutDocs': 'Poster uten dokumentasjon',
  'avh.doc.document': 'Dokument',
  'avh.doc.source': 'Kilde',
  'avh.doc.link': 'Kobling',
  'avh.doc.controlStatus': 'Kontrollstatus',
  'avh.doc.other': 'Annet',
  'avh.doc.client': 'Klienten',
  'avh.doc.firm': 'Byrået',
  'avh.doc.linked': 'Koblet',
  'avh.doc.notLinked': 'Ikke koblet',
  'avh.doc.checkedOne': 'Kontrollert',
  'avh.doc.uncheckedOne': 'Ikke kontrollert',
  'avh.doc.view': 'Vis',
  'avh.doc.reopenCheck': 'Gjenåpne kontroll',
  'avh.doc.markChecked': 'Marker kontrollert',
  'avh.doc.empty': 'Ingen dokumenter er lagt ved øvrig balanse i denne perioden. Bruk dokumentfanen i høyrepanelet for å legge dem ved.',
  'avh.doc.missingRequirements': 'Manglende dokumentkrav',
  'avh.doc.specCheck': 'Spesifikasjonskontroll',
  'avh.doc.difference': 'Differanse',
  'avh.doc.sumSpecifiedOpen': 'Sum spesifiserte åpne poster',
  'avh.doc.notFullySpecified': 'Saldoen er ikke fullt spesifisert. Differansen er som regel en inngående balanse som er importert uten underliggende posteringer — den må spesifiseres for hånd på kontoen.',
  'avh.doc.docAssessmentCheck': 'Dokumentasjons- og vurderingskontroll',
  'avh.doc.notFullyDocumented': 'Ikke fullt dokumentert',
  'avh.doc.fullyAssessed': 'Fullt vurdert',
  'avh.doc.documentedBalance': 'Dokumentert saldo',
  'avh.doc.fullyAssessedBalance': 'Fullt vurdert saldo',
  'avh.doc.balanceSummary': '{documented} har tilknyttet dokumentasjon. Av dette er {pending} ikke ferdig vurdert for gjenvinnbarhet. Fullt faglig vurdert saldo er derfor {assessed}.',
  'avh.doc.autoCheck': 'Automatisk kontroll',
  'avh.doc.doneByPlumme': 'Utført av Plumme',
  'avh.doc.autoCheckText': 'Plumme har lest hovedboken til og med {date} og kontrollert at summen av de spesifiserte postene ({specified}) stemmer med den bokførte saldoen ({booked}). Dette er en teknisk kontroll — den bekrefter ikke at dokumentasjonen er tilstrekkelig, at gamle poster er reelle og gjenvinnbare, eller at avstemmingen er klar til kontroll.',
  'avh.doc.notConfirmed': 'Ikke bekreftet',
  'avh.doc.confirmText': 'En person må bekrefte at dokumentasjonen er tilstrekkelig, at gamle poster er reelle og gjenvinnbare, at periodiseringene er faglig riktige, at alle vesentlige avvik er behandlet, og at avstemmingen er klar til kontroll.',
  'avh.doc.confirmSavedAs': 'Bekreftelsen lagres som kontrollpunktet «{label}» i den faglige sjekklista — ett sted, slik at kontrolløren finner den der hen ser etter.',
  'avh.doc.cannotConfirm': 'Kan ikke bekreftes før manglende dokumentasjon, gjenstående vurderinger og spesifikasjonsdifferansen er behandlet.',
  'avh.doc.confirmCheck': 'Bekreft faglig kontroll',
  'avh.doc.pointMissing': 'Kontrollpunktet finnes ikke i denne periodens sjekkliste.',
  'avh.adj.pickAccount': 'Velg kontoen posten gjelder.',
  'avh.adj.enterAmount': 'Skriv et beløp.',
  'avh.adj.enterReason': 'Skriv hva posten skyldes. Uten begrunnelse teller den ikke som forklart.',
  'avh.adj.description': 'Beskrivelse',
  'avh.adj.date': 'Dato',
  'avh.adj.amount': 'Beløp',
  'avh.adj.classification': 'Klassifisering',
  'avh.adj.missingReason': 'Mangler begrunnelse',
  'avh.adj.resolved': 'Løst',
  'avh.adj.open': 'Åpen',
  'avh.adj.markUnresolved': 'Merk uløst',
  'avh.adj.markResolved': 'Marker løst',
  'avh.adj.delete': 'Slett',
  'avh.adj.reasonPlaceholder': 'Hva skyldes posten?',
  'avh.adj.chooseAccount': 'Velg konto',
  'avh.adj.add': 'Legg til',
  'avh.adj.none': 'Ingen avstemmingsposter registrert.',
  'avh.adj.note': 'Postene er korrigeringsforslag til godkjenning — ingenting bokføres automatisk.',
  'avh.derived.documented': 'Alle åpne poster har dokumentasjon',
  'avh.derived.existence': 'Eksistensen av alle åpne poster er bekreftet',
  'avh.derived.subsequent': 'Etterfølgende oppgjør er kontrollert',
  'avh.derived.recoverability': 'Gjenvinnbarheten av alle åpne poster er vurdert',
  'avh.derived.old': 'Poster eldre enn 90 dager er ferdig vurdert',
  'avh.derived.noCounterparty': 'Poster uten identifisert motpart er avklart',
  'avh.derived.unusualSign': 'Poster med uvanlig fortegn er undersøkt',
  'avh.derived.manualPeriodEnd': 'Manuelle periodesluttposteringer er vurdert',
  'avh.ck.noPoints': 'Ingen kontrollpunkter er definert for øvrig balanse i denne perioden.',
  'avh.ck.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avh.ck.pointsNote': 'Punktene gjelder hele området. En avkryssing lagres på alle kontoene i øvrig balanse.',
  'avh.ck.groupItems': 'Poster som krever behandling',
  'avh.ck.processedOf': '{done} av {total} behandlet',
  'avh.ck.notApplicable': 'Ikke aktuelt denne perioden',
  'avh.ck.overThreshold': ' · {count} over vesentlighetsgrensen',
  'avh.ck.followsAssessments': 'Følger av vurderingene',
  'avh.ck.groupPerAccount': 'Per konto',
  'avh.ck.itemsAssessed': '{done} av {total} poster ferdig vurdert',
  'avh.ck.noOpenItems': 'Ingen åpne poster',
  'avh.ck.notSpecifiedAmount': ' · ikke spesifisert: {amount}',
  'avh.ck.noAccounts': 'Ingen kontoer i området.',
  'avh.ck.groupOverall': 'Overordnede faglige vurderinger',
  'avh.ck.groupReady': 'Klarstilling',
  'avh.ck.performedBy': 'Utføres av {name} · ',
  'avh.ck.pointsDone': '{done} av {total} kontrollpunkter fullført',
  'avh.bl.unspecified': 'Saldoen er ikke fullt spesifisert — {amount} står uforklart',
  'avh.bl.docsMissing': 'Underliggende dokumentasjon mangler for {amount}',
  'avh.bl.existenceOne': 'Eksistensen av {count} post er ikke bekreftet',
  'avh.bl.existenceMany': 'Eksistensen av {count} poster er ikke bekreftet',
  'avh.bl.recoverability': 'Gjenvinnbarheten av {amount} må vurderes',
  'avh.bl.oldOne': '{count} post over 90 dager er ikke ferdig behandlet',
  'avh.bl.oldMany': '{count} poster over 90 dager er ikke ferdig behandlet',
  'avh.bl.adjustmentOne': '{count} avstemmingspost er åpen',
  'avh.bl.adjustmentMany': '{count} avstemmingsposter er åpne',
  'avh.bl.pointOne': '{count} kontrollpunkt er ikke fullført',
  'avh.bl.pointMany': '{count} kontrollpunkter er ikke fullført',
  'avh.bl.criticalNoReason': '{count} kritisk avvik mangler begrunnelse',
  'avh.concl.title': 'Konklusjon og godkjenning',
  'avh.concl.accountsInArea': 'Kontoer i området',
  'avh.concl.documentedNotAssessed': 'Dokumentert, men ikke ferdig vurdert',
  'avh.concl.incompletePoints': 'Ufullførte kontrollpunkter',
  'avh.concl.done': 'Utført',
  'avh.concl.missing': 'Mangler',
  'avh.concl.notReady': 'Ikke klar til kontroll',
  'avh.concl.ready': 'Klar til kontroll',
  'avh.concl.placeholder': 'Hva består saldoene av, hva er dokumentert og vurdert, og hva står igjen?',
  'avh.concl.savedAs': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avh.concl.periodNotLocked': 'Perioden er ikke låst — bilag kan fortsatt bokføres og endre grunnlaget.',
  'avh.concl.periodNotEnded': 'Perioden er ikke avsluttet. Avstemmingen gjelder grunnlaget per {date} og må gjentas etter periodeslutt.',
  'avh.concl.nothingLeft': 'Ingenting står igjen som hindrer at området sendes til kontroll. Området har ingen ekstern saldo — at spesifikasjonen summerer seg til hovedboken er en teknisk kontroll, og det er vurderingen av hver post som bærer konklusjonen.',
  'avh.concl.noFollowUps': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'avh.concl.followed': 'Følges opp',
  'avh.concl.noAction': 'Ingen tiltak notert',
  'avh.concl.deadline': ' · Frist {date}',
  'avh.concl.openAssessment': 'Åpne vurdering',
  'avh.concl.sendArea': 'Send området til kontroll',
  'avh.concl.leftOne': 'Én ting står igjen før området kan sendes.',
  'avh.concl.leftMany': '{count} ting står igjen før området kan sendes.',
  'avh.quick.needsAssessment': 'Krever vurdering',
  'avh.quick.allOpen': 'Alle åpne',
  'avh.quick.withoutDocs': 'Uten dokumentasjon',
  'avh.quick.overThreshold': 'Over vesentlighetsgrensen',
  'avh.quick.noMovement': 'Uten bevegelse',
  'avh.quick.manualPeriodEnd': 'Manuelt ved periodeslutt',
  'avh.quick.fullyAssessed': 'Ferdig vurdert',
  'avh.pg.noRecAccount': 'Øvrig balanse har ingen avstemmingskonto i denne perioden.',
  'avh.pg.accountsCount': '{count} kontoer',
  'avh.pg.toAssess': '{count} må vurderes',
  'avh.pg.documentation': 'Dokumentasjon',
  'avh.pg.amountMissing': '{amount} mangler',
  'avh.pg.complete': 'Komplett',
  'avh.pg.amountUnspecified': '{amount} uspesifisert',
  'avh.pg.openCount': '{count} åpne',
  'avh.pg.notReady': 'Ikke klar',
  'avh.pg.areaLabel': 'Øvrig balanse',
  'avh.pg.hintUnassessed': '{count} åpne poster er ikke ferdig vurdert.',
  'avh.pg.hintAllAssessed': 'Alle åpne poster er ferdig vurdert.',
  'avh.pg.title': 'Øvrig balanse — spesifikasjon av restkontoene',
  'avh.pg.dataThrough': ' · Datagrunnlag til og med {date}',
  'avh.pg.responsible': ' · Ansvarlig {name}',
  'avh.pg.materialityLine': ' · Vesentlighetsgrense {value}',
  'avh.pg.notSetLower': 'ikke satt',
  'avh.pg.needAssessment': '{count} poster krever vurdering',
  'avh.pg.noOpenIssues': 'Ingen åpne forhold',
  'avh.pg.scope': 'Området omfatter balansekontoene som ikke avstemmes i egne områder for bank, kunder, leverandører, lønn, avgifter, skatt, eiendeler, lån eller egenkapital.',
  'avh.pg.accountCount': 'Antall kontoer',
  'avh.pg.totalAssets': 'Samlet bokført eiendelssaldo',
  'avh.pg.totalLiabilities': 'Samlet bokført gjeldssaldo',
  'avh.pg.openItemCount': 'Antall åpne poster',
  'avh.pg.itemsOlder90': 'Poster eldre enn 90 dager',
  'avh.pg.settledItems': 'Oppgjorte poster',
  'avh.pg.noExternalBalance': 'Øvrig balanse har ingen ekstern saldo. Spesifikasjonen og hovedboken er begge foretakets egne kilder, og en post som aldri var reell står i begge. Eksistens, motpart og gjenvinnbarhet bekreftes derfor per post — ikke av at to tall er like.',
  'avh.pg.periodOverNotLocked': 'Perioden er over, men ikke låst. Bilag kan fortsatt bokføres og endre grunnlaget avstemmingen hviler på. Lås perioden når den er ferdig.',
  'avh.pg.periodNotEnded': 'Perioden er ikke avsluttet. Dette er en foreløpig avstemming per {date}. Resten av månedens bilag finnes ikke ennå, og endelig hovedbok må hentes etter periodeslutt før avstemmingen kan ferdigstilles.',
  'avh.pg.noAccountsMove': 'Ingen kontoer er lagt til øvrig balanse i denne perioden. Kontoer som ikke hører hjemme her flyttes til sitt eget område fra kontooversikten.',
  'avh.pg.accountingData': 'Regnskapsdata',
  'avh.pg.fetchedFrom': 'Hentet fra saldobalansen og hovedboken',
  'avh.pg.perDate': ' per {date}',
  'avh.pg.kpiAssets': 'Bokført eiendelssaldo',
  'avh.pg.kpiLiabilities': 'Bokført gjeldssaldo',
  'avh.pg.kpiPrevious': 'Saldo forrige periode',
  'avh.pg.kpiChange': 'Endring',
});
